<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "SalesIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
